import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
import _objectWithoutProperties from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from "@/api/PMS/blackListManage/index";
import waves from "@/directive/waves"; // 水波纹指令

import deviceAdd from "./add";
import { formatJson } from "@/utils/index";
import importExcel from "./import";
export default {
  name: "ComplexTable",
  directives: {
    waves: waves
  },
  components: {
    deviceAdd: deviceAdd,
    importExcel: importExcel
  },
  props: {
    showDialog: Boolean,
    keyValue: {
      type: Number,
      default: -1
    },
    tableRow: Object
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  data: function data() {
    return {
      // pickerOptions: {
      //   shortcuts: [
      //     {
      //       text: "最近一周",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "最近一个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     },
      //     {
      //       text: "最近三个月",
      //       onClick(picker) {
      //         const end = new Date();
      //         const start = new Date();
      //         start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      //         picker.$emit("pick", [start, end]);
      //       }
      //     }
      //   ]
      // },
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      id: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      dialogExcelVisible: false
    };
  },
  created: function created() {
    this.init();
  },
  methods: {
    init: function init() {
      this.$set(this.listQuery, "activityManageId", this.keyValue);
      this.getList();
    },
    // 导入
    handleUpload: function handleUpload() {
      this.title = "导入Excel";
      this.dialogExcelVisible = true;
    },
    handleRegistrationDate: function handleRegistrationDate(val) {
      if (val && val.length > 0) {
        this.$set(this.listQuery, "rangeDate", val);
        this.$set(this.listQuery, "startDate", val[0]);
        this.$set(this.listQuery, "endDate", val[1]);
      }
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogExcelVisible = false;
      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;

      var _this$listQuery = this.listQuery,
          rangeDate = _this$listQuery.rangeDate,
          listQuery = _objectWithoutProperties(_this$listQuery, ["rangeDate"]);

      fetchList(listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.id = -1;
      this.title = "创建";
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(id) {
      this.id = id;
      this.title = "编辑";
      this.dialogFormVisible = true;
    },
    delete: function _delete(deviceIds) {
      var _this2 = this;

      if (deviceIds.length > 0) {
        this.$confirm("你确定是要删除这些记录, 是否继续?", "提示").then(function () {
          fetchDelete(deviceIds).then(function (response) {
            _this2.getList();

            _this2.Alert({
              alertType: "delete"
            });
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(id) {
      var deviceIds = [];
      deviceIds.push(id);
      this.delete(deviceIds);
    },
    handleDeletes: function handleDeletes() {
      var deviceIds = [];
      this.multipleSelection.forEach(function (row) {
        deviceIds.push(row.id);
      });
      this.delete(deviceIds);
    },
    // handleBatchCreate() {
    //   this.id = -1;
    //   this.title = "批量新增";
    //   this.dialogFormVisible = true;
    // },
    // 导出
    handleExport: function handleExport() {
      var _this3 = this;

      this.exLists = [];
      var activityTitle = this.tableRow.activityTitle;
      this.$confirm("\u4F60\u786E\u5B9A\u8981\u5BFC\u51FA".concat(activityTitle, "-\u9ED1\u540D\u5355\u5217\u8868\u5417, \u662F\u5426\u7EE7\u7EED?"), "提示").then(function () {
        var _this3$listQuery = _this3.listQuery,
            rangeDate = _this3$listQuery.rangeDate,
            listQuery = _objectWithoutProperties(_this3$listQuery, ["rangeDate"]);

        fetchList(listQuery).then(function (response) {
          var list = response.data.data;

          if (list !== null && list.length > 0) {
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["用户姓名", "联系方式", "开始时间", "结束时间"];
              var fileterVal = ["name", "tel", "startDate", "endDate"];
              var data = formatJson(fileterVal, list);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: "".concat(activityTitle, "\u9ED1\u540D\u5355\u5217\u8868"),
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this3.Alert({
              alertType: "error",
              message: "暂无数据，无法导出！"
            });
          }
        });
      });
    }
  }
};